<p-toast class="no-summary" position="top-center" [key]="GLOBAL_TOAST_KEY"></p-toast>
<!-- Main Router -->
<div id="body" [ngClass]="(cssClasses$ | async) ?? ''">
  <router-outlet></router-outlet>
  <ng-container *ngIf="isBrowser">
    <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
  </ng-container>
  <app-loading-spinner [fullScreen]="true" [loading]="loading$ | async"></app-loading-spinner>
</div>
